import { render, staticRenderFns } from "./RoulInfo.vue?vue&type=template&id=133d6cf7&scoped=true&"
import script from "./RoulInfo.vue?vue&type=script&lang=js&"
export * from "./RoulInfo.vue?vue&type=script&lang=js&"
import style0 from "./RoulInfo.vue?vue&type=style&index=0&id=133d6cf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133d6cf7",
  null
  
)

export default component.exports